import React from 'react';
import Link from 'gatsby-link';
import Scrollchor from 'react-scrollchor';
import ScrollAnimation from 'react-animate-on-scroll';
import PropTypes from 'prop-types';
 
//import BurgerMenu from 'react-burger-menu';

import logo from '../assets/images/logo_blanc_full_small.png';


class Header extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showBackButton: false,
	  showBackgroundHeader: false
    }
	this.handleScroll = this.handleScroll.bind(this);
  }

  showSettings (event) {
    event.preventDefault();
  }

  componentDidMount() {
	if(typeof window !== 'undefined'){
      window.addEventListener('scroll', this.handleScroll);
	}
  }

  componentWillUnmount() {
	if(typeof window !== 'undefined'){
      window.removeEventListener('scroll', this.handleScroll);
	}
  }

  componentWillReceiveProps() {
    this.setState({
		showBackButton: window.location.pathname.match('/.*/')
    })
  }


  handleScroll(event) {
	//console.log(document.body);
	
		if(typeof document !== 'undefined' && document.scrollingElement !== undefined && document.scrollingElement.scrollTop === 0) {
    		// Top level window
			this.setState({
          		showBackgroundHeader: false
    		});
		} else {
    		// Not top level. An iframe, popup or something
			this.setState({
          		showBackgroundHeader: true
    		});
		}
	
  }

  render() {
	const { showBackButton,showBackgroundHeader } = this.state; 
	const headerClass = showBackgroundHeader ? "alt darkheader inline-top" : "alt inline-top";
	//<a className="menu-link" onClick={this.props.onToggleMenu} href="javascript:;">Menu</a>
	//<Scrollchor to="#contact">Contact <span className="icon fa-envelope"></span></Scrollchor>
	//<div className="right"><BMenu id='pushRotate' isOpen={isOpen} pageWrapId={'wrapper'} outerContainerId={'root'} right>{items}</BMenu></div>
	//const BMenu = BurgerMenu['push'];
	//const isOpen = this.props.isOpen;

	//{showBackButton && <Link className="button special small vertical-align" to="/"><span className="icon fa-chevron-left"></span> Accueil</Link>}
	//{showBackButton && <Link className="button small vertical-align" to="/"><span className="icon fa-2x fa-home"></span></Link>}
	return (
	<header id="header" className={headerClass}>
		<nav>
			<Scrollchor to="#contact" title="Contact">Contact <span className="icon fa-envelope"></span></Scrollchor>
		</nav>
		{showBackButton && <Link className="button special small vertical-align" title="Accueil" to="/"><span className="icon fa-2x fa-home"></span></Link>}
    </header>
	)
  }

}

Header.propTypes = {
    onToggleMenu: PropTypes.func
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header.js